export enum SearchConsoleTab {
    Situation = 'situation',
    Worklist = 'worklist',
    Explain = 'explain',
    Preview = 'preview',
    Judgement = 'judgement',
    Dictionary = 'dictionary',
    Curation = 'curation',
}
